export function formatType(value) {
  switch (value) {
    case 1:
      return "Suporte";
    case 2:
      return "Pedido";
    default:
      return value;
  }
}

export function formatStatus(value) {
  switch (value) {
    case 1:
      return "Aberto";
    case 2:
      return "Em progresso";
    case 3:
      return "Cancelado";
    case 4:
      return "Fechado";
    default:
      break;
  }
}

export function formatSide(value) {
  switch (value) {
    case 1:
      return "Cliente";
    case 2:
      return "Negócio";
    default:
      return "Sem dependentes";
  }

}

/* Funções Auxiliares - datas */
// Função auxiliar necessária para as datas que vêm com data e hora por serem ambas precisas - filtrar data
export function formatDate(dateString, separator = '') {
  return `${dateString.substr(0, 2)}${separator}${dateString.substr(3, 2)}${separator}${dateString.substr(6, 4)}`
}

// Função auxiliar necessária para as datas que vêm com data e hora por serem ambas precisas - filtrar hora
export function formatDateToHours(strDate) {
  return `${strDate.substr(11, 5)}`
}

// Função auxiliar necessária à formatação de datas provenientes do elemento 'DatePicker'
export function formatDateStandard(date, separator = '/') {
  return (date.getDate() > 9 ? date.getDate() : '0' + date.getDate()) + separator + (date.getMonth() > 8 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)) + separator + date.getFullYear();
}

export function getCurrentDate(separator = "/") {
  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();

  return `${date < 10 ? `0${date}` : `${date}`}${separator}${month < 10 ? `0${month}` : `${month}`}${separator}${year}`
}

export function addYearsDate(strDate, years) {
  let date = new Date(strDate);
  date.setFullYear(date.getFullYear() + years);
  return date;
}

export function subtractYearsDate(date, years) {
  const dateCopy = date;
  dateCopy.setFullYear(date.getFullYear() - years);
  return dateCopy;
}

export function addDaysDate(date, days) {
  const dateCopy = date;
  dateCopy.setDate(dateCopy.getDate() + days);
  return dateCopy;
}

export function subtractDaysDate(date, days) {
  const dateCopy = date;
  dateCopy.setDate(dateCopy.getDate() - days);
  return dateCopy;
}

export function replaceStr(str, len = 0, replacer) {
  const length = len > str.length ? str.length : len, set = new Set(), newStr = [];

  while (set.size !== length) {
    set.add(Math.floor(Math.random() * str.length));
  }

  for (let i = 0; i < str.length; ++i) {
    set.has(i) ? newStr.push(replacer) : newStr.push(str[i]);
  }

  return newStr.join("");
}

export function validateNIF(value) {
  const nif = typeof value === 'string' ? value : '';

  const validationSets = {
    one: ['1', '2', '3', '5', '6', '8'],
    two: ['45', '70', '71', '72', '74', '75', '77', '79', '90', '91', '98', '99']
  };

  if (nif.length !== 9) {
    return false;
  }

  if (!validationSets.one.includes(nif.substring(0, 1)) && !validationSets.two.includes(nif.substring(0, 2))) {
    return false;
  }

  const total = nif[0] * 9 + nif[1] * 8 + nif[2] * 7 + nif[3] * 6 + nif[4] * 5 + nif[5] * 4 + nif[6] * 3 + nif[7] * 2;
  const modulo11 = (Number(total) % 11);
  const checkDigit = modulo11 < 2 ? 0 : 11 - modulo11;

  return checkDigit === Number(nif[8]);
}

export function hideCookieButton() {
  const checkForButton = () => {
    var cookieButton = document.querySelector(".ot-floating-button");
    if (cookieButton) {
      cookieButton.style.display = "none"; // Esconde o botão
    } else {
      setTimeout(checkForButton, 100); // Tenta novamente após 100ms
    }
  }

  checkForButton();
}
